import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./home";
import ServicesListing from "./components/services";
import ERROR from "./404";
import ServicePage from "./components/ServicePage";
import Checklists from "./pages/checklists/Checklists";
import ChecklistPage from "./pages/checklists/ChecklistPage";
import CustomChecklist from "./pages/checklists/CustomChecklist";
import SharedChecklistPage from "./pages/checklists/SharedChecklistPage";

import ScrollToTop from "./components/ScrollToTop";

import PrivacyPolicyPage from "./pages/Privacy";
import DisclaimerPage from "./pages/Disclaimer";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/404" element={<ERROR />} />
          <Route path="/services" element={<ServicesListing />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/checklists" element={<Checklists />} />
          <Route path="/checklists/:slug" element={<ChecklistPage />} />
          <Route path="/checklists/custom/new" element={<CustomChecklist />} />
          <Route path="/checklists/shared" element={<SharedChecklistPage />} />
          <Route path="*" element={<ERROR />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
